var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "VueToNuxtLogo" }, [
      _c("div", { staticClass: "Triangle Triangle--two" }),
      _vm._v(" "),
      _c("div", { staticClass: "Triangle Triangle--one" }),
      _vm._v(" "),
      _c("div", { staticClass: "Triangle Triangle--three" }),
      _vm._v(" "),
      _c("div", { staticClass: "Triangle Triangle--four" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }